import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";


type Props = {
  onActionEditar: (idItemchecklist: number | null, openState: boolean) => void;
  onActionDeletar: (idItemchecklist: number | null, openState: boolean) => void;
  onActionDownload: (id: number, imageName: string) => void;
};

export const GenerateAnexarDocumentosColumnDefinition = ({ onActionEditar, onActionDeletar, onActionDownload }: Props): GridColDef[] => {
  return [
    {
      field: "Descricao",
      headerName: "Descrição",
      flex: 1,
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "Arquivo",
      filterable: false,
      headerName: "Arquivo",
      width: 175,
      sortable: false,
      resizable: false,
      renderCell: (params) => {
        const maxSize = 20;
        const nome = params.row["Nome"] as string;
        const IdProjetoArquivo = params.row["IdProjetoArquivo"] as number;
        return (

          <Button
            onMouseDown={() => onActionDownload(IdProjetoArquivo, nome)}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".3rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
              width: "9.5rem",
            }}
          >
            {nome && nome.length > maxSize ? `${nome.substring(0, maxSize)}...` : nome}
          </Button>
        );
      },
    },
    {
      field: "IdProjetoArquivo",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
